import { render, staticRenderFns } from "./WorkRegistrationDetail.vue?vue&type=template&id=bcaa0360&"
import script from "./WorkRegistrationDetail.vue?vue&type=script&lang=js&"
export * from "./WorkRegistrationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports